import React, { FC, memo, useMemo } from 'react';
import { Wrapper } from './components';
import View from './components/View';
import { Button, Empty, Rate } from 'udesk-ui';
import Udesk from 'Udesk';
import uniqueId from 'lodash/uniqueId';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    inspectDataSource?: number;
    data?: Record<string, any>[];
    isOriginText?: boolean;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { inspectDataSource, data, isOriginText } = props;

    const isEComment = useMemo(
        () => inspectDataSource === Udesk.enums.inspectDataSources.eComment.id,
        [inspectDataSource]
    );

    return (
        <>
            {data?.length ? (
                data?.map((item, index) => (
                    <Wrapper key={uniqueId('comment_')}>
                        {index === 0 ? (
                            <View
                                avatar={isEComment ? item.productPicture : item.picture}
                                header={isEComment ? item.productTitle : item.title}
                                actions={
                                    <Button
                                        type="link"
                                        size="small"
                                        href={isEComment ? item.productLink : item.link}
                                        target="_blank"
                                    >
                                        {/* 查看详情 */}
                                        {
                                            UdeskLocales['current'].components.audioCallContentInfo
                                                .components.commentView.index.viewDetails
                                        }
                                    </Button>
                                }
                                title={isEComment ? item.productTitle : item.title}
                                footer={isEComment ? item.productUpdateTime : item.publishTime}
                            />
                        ) : null}

                        <View
                            header={item.commenter}
                            actions={
                                <Button type="link" size="small" href={item.site} target="_blank">
                                    {item.domainSite}
                                </Button>
                            }
                            title={item.commentTitle}
                            extra={
                                isEComment ? (
                                    <Rate
                                        value={item.commentStar}
                                        allowHalf
                                        disabled
                                        style={{ fontSize: 14 }}
                                    />
                                ) : null
                            }
                            content={
                                isOriginText ? item.originContent || item.content : item.content
                            }
                            footer={item.commentUpdateTime}
                        />
                    </Wrapper>
                ))
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </>
    );
});

export default Template;
